/* Progressive chapter markers and topic media. No text replacement or commerce hooks. */
(function(){'use strict';
 function enhance(scope){
  var bank=document.querySelector('[data-cp-reading-media]');
  (scope||document).querySelectorAll('[data-cp292-body], [data-cpb-content]').forEach(function(body){
   if(body.dataset.cpReadingFinish)return;
   body.dataset.cpReadingFinish='true';
   if(body.matches('[data-cpb-content]')){
    Array.from(new Set(Array.from(body.querySelectorAll('h2')).map(function(h){return h.parentElement;}))).forEach(function(parent){
     if(parent.classList.contains('cp292-chapter'))return;
     var chapter=null;Array.from(parent.childNodes).forEach(function(node){
      if(node.nodeType===1&&node.tagName==='H2'){chapter=document.createElement('section');chapter.className='cp292-chapter';parent.insertBefore(chapter,node);}
      if(chapter)chapter.appendChild(node);
     });
    });
   }
   var used={},count=0;
   body.querySelectorAll('.cp292-chapter').forEach(function(chapter,index){
    var heading=chapter.querySelector('h2');if(!heading)return;
    var title=heading.textContent.toLowerCase(),topic='';
    if(/clean|care|maintain|maintenance|support|servic/.test(title))topic='care';
    else if(/ingredient|beans|chocolate|matcha|milk powder/.test(title))topic='ingredients';
    else if(/water|hydration|cooler|filtrat/.test(title))topic='water';
    else if(/site|plan|demand|brief|rental|purchase|cost|budget|installation/.test(title))topic='planning';
    else if(/coffee|drink|machine|format/.test(title))topic='coffee';
    var marker=document.createElement('div');marker.className='cp-reading-marker';marker.setAttribute('aria-hidden','true');
    var number=document.createElement('b');number.textContent=String(index+1).padStart(2,'0');marker.appendChild(number);
    marker.appendChild(document.createTextNode(topic==='care'?'Daily care':topic==='ingredients'?'Ingredients':topic==='water'?'Water':topic==='planning'?'Planning':'In detail'));
    heading.before(marker);
    if(!bank||!topic||used[topic]||count>=3||chapter.querySelector('img,video,iframe')||chapter.textContent.length<220)return;
    var template=bank.querySelector('[data-cp-reading-topic="'+topic+'"]');if(!template)return;
    heading.after(template.content.cloneNode(true));used[topic]=true;count++;
   });
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){enhance(document);});else enhance(document);
 document.addEventListener('shopify:section:load',function(e){enhance(e.target);});
})();
